import { render, staticRenderFns } from "./CarrierBookingHistory.vue?vue&type=template&id=38d5c0d8&scoped=true&"
import script from "./CarrierBookingHistory.vue?vue&type=script&lang=js&"
export * from "./CarrierBookingHistory.vue?vue&type=script&lang=js&"
import style0 from "./CarrierBookingHistory.vue?vue&type=style&index=0&id=38d5c0d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5c0d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d5c0d8')) {
      api.createRecord('38d5c0d8', component.options)
    } else {
      api.reload('38d5c0d8', component.options)
    }
    module.hot.accept("./CarrierBookingHistory.vue?vue&type=template&id=38d5c0d8&scoped=true&", function () {
      api.rerender('38d5c0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JobOffers/CarrierBookingHistory.vue"
export default component.exports